import { useNavigate } from "react-router-dom";
import styles from '../cssModules/index.module.css';
import { Dropdown, Form } from 'react-bootstrap';


export default function BackpackUpdate({ id, prod, setProd, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');
    // const { prodId } = useParams();
    // const [prod, setProd] = useState({});
    const navigate = useNavigate();

    const userSegment = ['Men', 'Women', 'Unisex'];

    const depth = [
        'Up to 9 cm',
        '10 to 14 cm',
        '15 to 24 cm',
        '25 cm & above'
    ];

    const waterResistance = [
        'Moisture Resistant',
        'Not Water Resistant',
        'Water Repellent',
        'Water Resistant',
        'Waterproof'
    ];

    const style = [
        'Laptop Backpack',
        'Daypack Backpack',
        'Backpack Handbag',
        'Framed Backpack'
    ];

    const design = [
        'Solid',
        'Floral',
        'Geometric',
        'Abstract',
        'Animal Print',
        'Argyle',
        'Camouflage',
        'Checkered',
        'Chevron',
        'Gingham',
        'Hearts',
        'Herringbone',
        'Houndstooth',
        'Ikat',
        'Letter Print',
        'Marble',
        'Moire',
        'Paisley',
        'Plaid',
        'Polka Dots',
        'Quilted',
        'Star',
        'String',
        'Striped',
        'Tie-Dye',
    ];

    const closureType = [
        'Zipper',
        'Magnetic',
        'Flap',
        'Buckle',
        'Button',
        'Clasp',
        'Drawstring',
        'Hook and Loop',
        'Kiss Lock',
        'Push Lock',
        'Snap',
        'Twist Lock'
    ];

    const shellType = [
        'Hard Shell',
        'Soft Shell'
    ]

    const pocketDesc = [
        'Utility Pocket',
        'Slash Pocket',
        'Water Bottle Pocket',
        'Bottom Shoe Storage Pocket',
        'Camera Pocket',
        'Electronics Pocket',
        'External Media Pocket',
        'Keys Pocket',
        'Map Pocket',
        'Passport Pocket',
        'Phone Pocket',
        'Powerbank Pocket',
        'Side Water Bottle Pocket',
        'Slip Pocket',
        'Slit Pocket',
        'Stash Pocket',
        'Sunglasses Pocket'
    ]

    const careInstruction = [
        'Dry Clean Only',
        'Hand Wash Only',
        'Machine Wash',
        'Wipe with Damp Cloth',
        'Wipe with Dry Cloth',
    ]

    const lifeStyle = [
        'Hiking',
        'Multi - Sport',
        'Trekking',
        'Airsoft',
        'Alpine Skiing',
        'Archery',
        'Auto Racing',
        'Backpacking',
        'Badminton',
        'Baseball',
        'Basketball',
        'BMX',
        'Boating',
        'Boxing',
        'Climbing',
        'Cricket',
        'Cycling',
        'Cyclocross',
        'Diving',
        'Football',
        'Golf',
        'Gymnastics',
        'Hunting',
        'Ice Skating',
        'Motorcycling',
        'Mountain Biking',
        'Mountaineering',
        'Paddle Boarding',
        'Rock Climbing',
        'Roller Skating',
        'Running',
        'Scuba Diving',
        'Skateboarding',
        'Snorkeling',
        'Snowboarding',
        'Soccer',
        'Surfing',
        'Swimming',
        'Tennis',
        'Yoga'
    ]

    const itemHeight = [
        'Up to 39 cm',
        '40 to 44 cm',
        '45 cm & above'
    ];

    const strapType = [
        'Shoulder Strap',
        'Adjustable',
        'Padded Strap',
        'Backstraps',
        'Basic',
        'Chain strap',
        'Chest Strap',
        'Compression Straps',
        'Convertible Strap',
        'Cross-Body',
        'Double Handle',
        'Handbag',
        'Handle(s)',
        'No Strap',
        'Removable Strap',
        'Retractable Strap',
        'Single Strap',
        'Top Handle',
        'Waist Strap'
    ];

    const liningDesc = [
        'Polyester',
        'Faux Leather',
        'Cotton',
        'Leather',
        'Acrylic',
        'Faux Fur',
        'Faux Suede',
        'Linen',
        'Nylon',
        'Plastic',
        'Polycotton',
        'Polyurethane',
        'Polyvinyl Chloride',
        'Rayon',
        'Silk',
        'Suede',
        'Vinyl'
    ];

    const color = ['red', 'darkred', 'tan', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];


    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)'];

    const stock = ['In stock', 'Out of stock'];

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL}/change/${id}`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify(prod),
                credentials: 'include'
            })
            if (response.status === 200) {
                alert('Updated the product!');
                navigate('/manage');
            } else {
                await loginStatus();
                navigate('/login');
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    const toggleSelection = (size, stock) => {
        try {
            let newArr;
            // prod = { 'additionSize': { 'XL': 20, 'xxl': 24, 'L': 10 } }
            if (stock) {
                // This will handle the situatioin when user already has size previously or not
                newArr = { ...prod['additionsize'], [size]: Number(stock) };
                setProd(prev => {
                    return { ...prev, "additionsize": newArr }
                });
            } else {
                if (Object.keys(prod['additionsize']).includes(size)) {
                    newArr = Object.fromEntries(
                        Object.entries(prod['additionsize']).filter(([key]) => {
                            return key !== size;
                        })
                    )
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                } else {
                    newArr = { ...prod["additionsize"], [size]: null }
                    setProd(prev => {
                        return { ...prev, "additionsize": newArr }
                    })
                }
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <>
            {prod && (
                <div className={`${styles.sellerUpdate}`}>
                    <form id='uploadForm' onSubmit={handleSubmit}>
                        <div className={`${styles.updateIndividualMainDiv}`}>
                            <img src={`${apiURL}/images/${prod.photo1}`} alt='img' className={`${styles.updateIndividualImage}`} />
                            <div className={`${styles.sellerUpdateDiv}`}>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='style'>
                                        Style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='style' name='style' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.style} selected hidden>{prod.style}</option>
                                        {style.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='userSegment'>
                                        User segment
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='userSegment' name='userSegment' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.userSegment} selected hidden>{prod.userSegment}</option>
                                        {userSegment.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='depth'>
                                        Depth
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='depth' name='depth' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.depth} selected hidden>{prod.depth}</option>
                                        {depth.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='shellType'>
                                        Shell type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='shellType' name='shellType' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.shellType} selected hidden>{prod.shellType}</option>
                                        {shellType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='pocketDescription'>
                                        Pocket description
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='pocketDescription' name='pocketDescription' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.pocketDescription} selected hidden>{prod.pocketDescription}</option>
                                        {pocketDesc.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='careInstruction'>
                                        Care instruction
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='careInstruction' name='careInstruction' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.careInstruction} selected hidden>{prod.careInstruction}</option>
                                        {careInstruction.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                {/* <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='itemLength'>
                                        itemLength
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='itemLength' name='itemLength' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.itemLength} selected hidden>{prod.itemLength}</option>
                                        {itemLength.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div> */}

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='lifeStyle'>
                                        Life style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='lifeStyle' name='lifeStyle' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.lifeStyle} selected hidden>{prod.lifeStyle}</option>
                                        {lifeStyle.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='strapType'>
                                        Strap type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='strapType' name='strapType' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.strapType} selected hidden>{prod.strapType}</option>
                                        {strapType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='waterResistance'>
                                        Water resistance
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='waterResistance' name='waterResistance' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.waterResistance} selected hidden>{prod.waterResistance}</option>
                                        {waterResistance.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='style'>
                                        Style
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='style' name='style' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.style} selected hidden>{prod.style}</option>
                                        {style.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='closureType'>
                                        Closure type
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='closureType' name='closureType' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.closureType} selected hidden>{prod.closureType}</option>
                                        {closureType.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='liningDesc'>
                                        Lining description
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='liningDesc' name='liningDesc' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.liningDesc} selected hidden>{prod.liningDesc}</option>
                                        {liningDesc.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='color'>
                                        Color
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.color} selected hidden>{prod.color}</option>
                                        {color.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='design'>
                                        Design
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='design' name='design' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.design} selected hidden>{prod.design}</option>
                                        {design.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='stock'>
                                        Stock
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='stock' name='active' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.active} selected hidden>{prod.active}</option>
                                        {stock.map(item => {
                                            return (
                                                <>
                                                    <option value={item}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='name'>
                                        Name
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='name' defaultValue={prod.name} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                                </div>


                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='price'>
                                        Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='price' defaultValue={prod.oldPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="price" name='oldPrice' />
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='dPrice'>
                                        Discount Price
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='dPrice' defaultValue={prod.currentPrice} onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: Number(e.target.value) }) })} required={true} type='number' placeholder="This price will be highlighted" name='currentPrice' />
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='weightCat'>
                                        Weight category (Courier ready)
                                    </label>
                                    <select className={`${styles.sellerUploadSelect}`} id='weightCat' name='weightCat' onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                        <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                        {weightCat.map(item => {
                                            return (
                                                <>
                                                    <option value={changeWeightCat(item)}>{item}</option>
                                                </>
                                            )
                                        })}
                                    </select>
                                </div>

                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary">Item height</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {itemHeight.map((option, idx) => (
                                                <>
                                                    <div className={`${styles.formControlDiv}`}>
                                                        <div style={{ flexBasis: '50%', fontSize: '13px' }}>
                                                            <Form.Check
                                                                key={idx}
                                                                type="checkbox"
                                                                label={option}
                                                                checked={Object.keys(prod['additionsize']).includes(option)}
                                                                onChange={() => toggleSelection(option, null, 'additionsize')}
                                                                className="px-3"
                                                            />
                                                        </div>
                                                        <div style={{ flexBasis: '50%' }}>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Stock'
                                                                key={idx}
                                                                value={prod['additionsize'][option] ? prod['additionsize'][option] : null}
                                                                onChange={(e) => toggleSelection(option, e.target.value, 'additionsize')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className={`${styles.sellerUploadLabelDiv}`}>
                                    <label for='sku'>
                                        Stock keeping unit
                                    </label>
                                    <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                        onChange={(e) => setProd(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="SKU" name='sku' />
                                </div>

                            </div>
                            <input type="submit" value='UPDATE' className={`${styles.sellerUpdateButton}`} />
                        </div>
                    </form>
                </div>
            )}
        </>
    )
}